<template>
    <v-card elevation="0" class="ma-0 pa-0">
        <p-f-u-edit-audience-popup ref="p-f-u-edit-audience-popup"></p-f-u-edit-audience-popup>
        <v-card-actions class="ma-0 pa-0 mt-1">
            <v-text-field
                style="margin-bottom: -30px"
                v-model="data"
                label="User ID"
                placeholder="Enter User Id"
                outlined
                clearable
                append-icon="mdi-account-search"
                @click:append="searchAcount"
                @keyup.enter="searchAcount"
            ></v-text-field>
        </v-card-actions>
        <v-card-actions class="ma-0 pa-0 mt-2">
            <v-card outlined class="pa-1 white--text" color="blue">
             User Info
            </v-card>
        </v-card-actions>
        <v-card-actions class="ma-0 pa-0 mt-2">
            <v-card width="100%" elevation="0" outlined v-if="visibleContent">
                <v-card-actions>
                    <h5>Name:</h5>
                    <h5 style="margin-left: 10px; color: green">{{ user.user_info.name }}</h5>
                </v-card-actions>
                <v-card-actions>
                    <h5>Uuid:</h5>
                    <h5 style="margin-left: 10px; color: green">{{ user.user_info.uid }}</h5>
                </v-card-actions>
                <v-card-actions>
                    <h5>Created:</h5>
                    <h5 style="margin-left: 10px; color: green">{{ user.user_info.created/1000 | formatDate }}</h5>
                </v-card-actions>
                <v-card-actions>
                    <h5>Last Login:</h5>
                    <h5 style="margin-left: 10px; color: green">{{ user.user_info.last_login/1000 | formatDate }}</h5>
                </v-card-actions>
                <v-card-actions>
                    <h5>Audience:</h5>
                    <v-btn :disabled="!ifCanChangeUserAudience()"
                            class="orange--text ml-2"
                           outlined
                           @click="onPressEditAudience(user)">
                        {{ this.user.user_info.audience || "-" }}
                        <v-icon size="20" class="ml-2">mdi-pencil-outline</v-icon>
                    </v-btn>
                </v-card-actions>
                <v-card-actions>
                    <h5>Save:</h5>
                    <v-btn :disabled="!ifCanExportSave()"
                            class="blue--text ml-2"
                           outlined
                           :loading="exporting"
                           @click="onPressExportSave(user)">
                        Export
                        <v-icon size="20" class="ml-2">mdi-database-export-outline</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-card-actions>
        <v-card-actions class="ma-0 pa-0 mt-2">
            <v-card outlined class="pa-1 white--text" color="blue">
                Snap Info
            </v-card>
        </v-card-actions>
        <v-card-actions class="ma-0 pa-0 mt-2">
            <v-card width="100%" elevation="0" outlined v-if="visibleContent">
                <v-card-actions>
                    <h5>Level:</h5>
                    <h5 style="margin-left: 10px; color: green">{{ user.snap_info.level }}</h5>
                </v-card-actions>
                <v-card-actions>
                    <h5>Created:</h5>
                    <h5 style="margin-left: 10px; color: green">{{ user.snap_info.created}}</h5>
                </v-card-actions>
                <v-card-actions>
                    <h5>Updated:</h5>
                    <h5 style="margin-left: 10px; color: green">{{ user.snap_info.updated }}</h5>
                </v-card-actions>
            </v-card>
        </v-card-actions>
        <v-card-actions class="ma-0 pa-0 mt-2">
            <v-card outlined class="pa-1 white--text" color="blue">
                User Profile
            </v-card>
        </v-card-actions>
        <v-card-actions class="ma-0 pa-0 mt-2">
            <v-card width="100%" elevation="0" outlined v-if="visibleContent">
                <v-card-actions>
                    <h5>Level:</h5>
                    <h5 style="margin-left: 10px; color: green">{{ user.user_profile.level }}</h5>
                </v-card-actions>
                <v-card-actions>
                    <h5>Currencies:</h5>
                </v-card-actions>
                <v-card v-for="currency in user.user_profile.currencies" :key="currency.kind" class="ma-0 pa-0" elevation="0" width="100%">
                    <v-card-actions class="ma-0 pa-0 mt-0" v-if="currency.kind != 0">
                        <v-card width="100%" class="pa-0 ma-2" elevation="0" outlined>
                            <v-card-actions>
                                <v-card elevation="0">
                                    <v-img max-width="30" :src="getUrl(getCurrency(currency.kind))"></v-img>
                                </v-card>
                                <v-card class="ml-4" elevation="0">
                                    Kind:<span style="color: orange; margin-left: 10px">{{getCurrency(currency.kind)}}</span>
                                </v-card>
                                <v-card class="ml-4" elevation="0">
                                    Amount:<span style="color: red; margin-left: 10px">{{currency.amount}}</span>
                                </v-card>
                                <v-card class="ml-4" elevation="0">
                                    Capacity:<span style="color: green; margin-left: 10px">{{currency.capacity}}</span>
                                </v-card>
                            </v-card-actions>
                        </v-card>
                    </v-card-actions>
                </v-card>
                <v-card-actions>
                </v-card-actions>
            </v-card>
        </v-card-actions>
            </v-card>
</template>

<script>

import {UsersBackendUtils} from "@/modules/mprofiles/database/UsersBackendUtils";
import PFUEditAudiencePopup from "@/modules/mprofiles/views/find-user/popups/p-f-u-edit-audience-popup";
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";
import {TimeUtils} from "@/common/TimeUtils";
import firebase from "firebase";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export default {
    name: "p-find-user",
    components: {PFUEditAudiencePopup},
    data: () => ({
        data: '',
        visibleContent: false,
        exporting:false,
        imagesUrls:{},
    }),
    methods: {
        getImage(id){
            firebase.storage()
                .ref('assets/currency/'+id+'.png')
                .getDownloadURL().then((url) => {
                this.imagesUrls[id] = url;
                this.$forceUpdate();
            }).catch(() => {
                console.log('assets/currency/'+id+'.png')
                this.imagesUrls[id] = require("@/modules/muiutils/resources/no-image-icon.png");
                this.$forceUpdate();
            });
        },
        getUrl(id){
            return this.imagesUrls[id]
        },
        getCurrency(kind){
            let value = RedactorUtils.getCurrencyKind()?.key === kind;
            if (value){
                return value.id
            }
            return ""
        },
        getDate(unix_timestamp){
            return new Date(unix_timestamp);
        },
        getMyUserUid(){
            return PermissionsStoreUtils.getMyUserUid();
        },
        ifCanExportSave(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.USERS_TAB.subpermissions.USERS_TAB_EXPORT_SAVE.id)
        },
        ifCanChangeUserAudience(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.USERS_TAB.subpermissions.USERS_TAB_CHANGE_AUD.id)
        },
        onPressExportSave(user){
            this.exporting = true
            UsersBackendUtils.fetchUserSave(user.user_info.uid).then((data) => {
                this.exporting = false
                let JSZip = require("jszip");
                let zip = new JSZip();
                let blob = new Blob(data, {type: "text/plain;charset=utf-8"});
                zip.file(user.user_info.uid + "_save.txt", blob);
                let promise = zip.generateAsync({type : "blob"})
                promise.then((blob) => {
                    let FileSaver = require('file-saver');
                    FileSaver.saveAs(blob, "shapshots_"+TimeUtils.now()+".zip");
                    if (this._onComplete){
                        this._onComplete(1);
                    }
                }).catch((error) => {
                    console.log("error:", error)
                    if (this._onComplete){
                        this._onComplete(0);
                    }
                })
                this.$notify({title: 'Save successfully exported!', type: "success"});
            }).catch((error) => {
                this.exporting = false
                this.$notify({title: 'Save exportd failed!', text: error, type: "error"});
            })
        },
        onPressEditAudience(user) {
            //console.log("uid:", user.user_info.uid)
            this.$refs['p-f-u-edit-audience-popup'].show(user.user_info.uid)
        },
        searchAcount() {
            if (this.data == null || this.data.length == 0) {
                this.$notify({title: 'empty user uid', type: "error"});
                return
            }
            UsersBackendUtils.fetchUser(this.data).then(() => {
                this.$notify({title: 'User successfully fetched!', type: "success"});
                this.visibleContent = true

                for (let c in this.user.user_profile.currencies){
                    let cur = this.user.user_profile.currencies[c];
                    let value = RedactorUtils.getCurrencyKind().key === cur.kind;
                    if (value){
                        this.getImage(value);
                    }
                }

            }).catch((error) => {
                this.$notify({title: 'User fetch failed!', text: error, type: "error"});
            })
        },
    },
    computed: {
        user() {
            //console.log(JSON.stringify(UsersBackendUtils.getUser()));
            return UsersBackendUtils.getUser()
        }
    }
}
</script>

<style scoped>
</style>